"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var ViewColumn_1 = __importDefault(require("@mui/icons-material/ViewColumn"));
var ColumnControllerUI = function (_a) {
    var columns = _a.columns, visibleColumns = _a.visibleColumns, setVisibleColumns = _a.setVisibleColumns, themeMode = _a.themeMode;
    var _b = (0, react_1.useState)(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleToggle = function (columnField) {
        var updatedColumns = visibleColumns.includes(columnField)
            ? visibleColumns.filter(function (field) { return field !== columnField; })
            : __spreadArray(__spreadArray([], visibleColumns, true), [columnField], false);
        setVisibleColumns(updatedColumns);
    };
    var open = Boolean(anchorEl);
    var id = open ? "column-controller-popover" : undefined;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Tooltip, { title: "Show/Hide Columns" },
            react_1.default.createElement(material_1.IconButton, { "aria-describedby": id, onClick: handleClick },
                react_1.default.createElement(ViewColumn_1.default, { color: "error" }))),
        react_1.default.createElement(material_1.Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
            }, transformOrigin: {
                vertical: "top",
                horizontal: "right",
            } },
            react_1.default.createElement(material_1.List, { dense: true, sx: {
                    backgroundColor: themeMode === "dark" ? "#302d4c" : "#e9e8ea",
                    color: themeMode === "dark" ? "white" : "black",
                } }, columns.map(function (column) { return (react_1.default.createElement(material_1.ListItem, { key: column.renderName, disablePadding: true },
                react_1.default.createElement(material_1.ListItemButton, { onClick: function () { return handleToggle(column.renderName); } },
                    react_1.default.createElement(material_1.ListItemText, { primary: column.headerName }),
                    react_1.default.createElement(material_1.Checkbox, { sx: {
                            color: "rgb(255, 78, 58)",
                            "&.Mui-checked": {
                                color: "rgb(255, 78, 58)",
                            },
                        }, checked: visibleColumns.includes(column.renderName) })))); })))));
};
exports.default = ColumnControllerUI;
